import React, { useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import useAuth from "../Auth/useAuth";

const Modal = () => {


  //home window
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  if (!user) {
    return <Navigate to="/login" />;
  }
  return (
    <div>
      jffbjj
    </div>
    // <div className="min-h-screen flex relative">
    //   {/* Desktop Menu */}
    //   <div
    //     className={`w-64 h-screen z-50 fixed top-0 hidden lg:block shadow-xl shadow-slate-500`}
    //   >
    //     <div className="py-6 pr-4 h-screen shadow-r-xl bg-slate-100 border border-r-slate-300">
    //       <div className="ml-4 mb-6 bg-slate-100 rounded-full">
    //         <img
    //           className="w-64 rounded-full mx-auto hover:cursor-pointer"
    //           src="../assets/menu.png"
    //           alt="logo"
    //           onClick={() => navigate("home")}
    //         />
    //       </div>

    //       <button
    //         className="py-1.5 px-3 m-2 w-full flex text-left text-neutral-700 shadow-sm font-semibold hover:bg-neutral-300 hover:shadow-neutral-600 duration-300"
    //         onClick={() => navigate("home")}
    //       >
    //         <RiDashboard2Fill className="mr-2 w-6 h-6" />
    //         Home
    //       </button>

    //       <button
    //         className="py-1.5 px-3 m-2 w-full flex text-left text-neutral-700 shadow-sm font-semibold hover:bg-neutral-300 hover:shadow-neutral-600 duration-300"
    //         onClick={() => navigate("projects")}
    //       >
    //         <RiDashboard2Fill className="mr-2 w-6 h-6" />
    //         Projects
    //       </button>

    //       <button
    //         className="py-1.5 px-3 m-2 w-full flex text-left text-neutral-700 shadow-sm font-semibold hover:bg-neutral-300 hover:shadow-neutral-600 duration-300"
    //         onClick={() => navigate("profile")}
    //       >
    //         <CgProfile className="mr-2 w-6 h-6" />
    //         My Profile
    //       </button>
    //     </div>
    //   </div>

    //   {/* Mobile Menu */}
    //   <div
    //     className={`z-50 fixed top-10 shadow-xl shadow-slate-500 duration-300 ${
    //       menuOpen ? "w-64 h-0" : "w-0 h-0"
    //     }`}
    //   >
    //     <div
    //       className={`py-6 h-screen shadow-r-xl bg-slate-100 border border-r-slate-300`}
    //     >
    //       <div className="ml-4 mb-6 bg-slate-100 rounded-full">
    //         <img
    //           className="w-64 rounded-full mx-auto hover:cursor-pointer"
    //           src={logo}
    //           alt="logo"
    //           onClick={() => navigate("home")}
    //         />
    //       </div>

    //       <button
    //         className={`py-1.5 px-3 my-2 flex text-left text-neutral-700 shadow-sm font-semibold hover:bg-neutral-300 hover:shadow-neutral-600 duration-300 ${
    //           menuOpen ? "w-full" : "hidden"
    //         }`}
    //         onClick={() => navigate("home")}
    //       >
    //         <BiHomeSmile className="mr-2 w-6 h-6" />
    //         Home
    //       </button>

    //       <button
    //         className={`py-1.5 px-3 my-2  flex text-left text-neutral-700 shadow-sm font-semibold hover:bg-neutral-300 hover:shadow-neutral-600 duration-300 ${
    //           menuOpen ? "w-full" : "hidden"
    //         }`}
    //         onClick={() => navigate("projects")}
    //       >
    //         <RiDashboard2Fill className="mr-2 w-6 h-6" />
    //         Projects
    //       </button>

    //       <button
    //         className={`py-1.5 px-3 my-2 flex text-left text-neutral-700 shadow-sm font-semibold hover:bg-neutral-300 hover:shadow-neutral-600 duration-300 ${
    //           menuOpen ? "w-full" : "hidden"
    //         }`}
    //         onClick={() => navigate("profile")}
    //       >
    //         <CgProfile className="mr-2 w-6 h-6" />
    //         My Profile
    //       </button>
    //     </div>
    //   </div>

    //   <div className={`lg:ml-64 w-full z-50}`}>
    //     <div className="py-auto h-10 md:h-16 px-4 z-50 bg-[#393939] sticky top-0 flex justify-between text-xl font-bold text-white shadow-sm shadow-neutral-400 duration-300">
    //       <div className="py-2 md:flex">
    //         <button
    //           className="mr-4 lg:hidden"
    //           onClick={() => setMenuOpen(!menuOpen)}
    //         >
    //           <i className="px-1 md:px-2 md:py-1 bi-list text-lg md:text-xl bg-neutral-700 text-white font-bold rounded-full" />
    //         </button>
    //         <label className="uppercase md:text-2xl text-lg duration-300">PROJECT MAN</label>
    //       </div>

    //       <div className="hidden sm:block">
    //         <h2 className="inline align-middle font-normal text-base">
    //           {user.email}
    //         </h2>
    //         <div
    //           onClick={logout}
    //           className="rounded-full bg-white h-8 w-8 text-neutral-600 text-center inline-block ml-2"
    //         >
    //           <i className="bi-power" />
    //         </div>
    //       </div>
    //     </div>
    //     <div className="min-h-screen bg-gray-200 dark:text-white">
    //       <Outlet />
    //     </div>
    //     <div className="bg-slate-500 px-4 py-4 text-white font-bold text-center">
    //       COPYRIGHT - BRAVISHMAH INFOTECH PRIVATE LIMITED
    //     </div>
    //   </div>
    // </div>
  );
};

export default Modal;




